import {Action} from '@ngrx/store';
import {Conversation} from '@app/core/models/conversation.model';
import {Message} from '@app/core/models/message.model';
import {ICreateMessageParams} from '@app/core/services/api/messages/messages.service';
import {Pagination} from '@app/core/models/pagination.model';
import {FileEntry} from '@app/core/models/fileEntry.model';

export enum EMessagesActions {
	GetConversations = '[Messages] Get Conversations',
	GetConversationsSuccess = '[Messages] Get Conversations Success',
	GetMessages = '[Messages] Get Messages',
	GetMessagesSuccess = '[Messages] Get Messages Success',
	CreateMessage = '[Messages] Create Message',
	CreateMessageSuccess = '[Messages] Create Message Success',
	FilterConversations = '[Messages] Filter Conversations',
	ClearFilteredConversations = '[Messages] Clear Filtered Conversations',
	CreateConversation = '[Messages] Create Conversation',
	CreateConversationSuccess = '[Messages] Create Conversation Success',

	ClearMessagesOnConversation = '[Messages] Clear Messages On Conversation',

	PostMessageFiles = '[Messages] Post Message Files',
	PostMessageFilesSuccess = '[Messages] Post Message Files Success',
	ClearMessageFiles = '[Messages] Clear Message Files',

	CreateNewConversation = '[Messages] Create New Conversation',

	SetSelectedConversation = '[Messages] Set Selected Conversation',

	SetShowOnlyMessages = '[Messages] Set Show Only Messages',

	LeaveConversation = '[Messages] Leave Conversation',
	LeaveConversationSuccess = '[Messages] Leave Conversation Success',

	RenameConversation = '[Messages] Rename Conversation',
	RenameConversationSuccess = '[Messages] Rename Conversation Success',

	PushMessageToConversation = '[Messages] Push message to conversation',
}

export class GetConversations implements Action {
	public readonly type = EMessagesActions.GetConversations;

	constructor() {
	}
}

export class GetConversationsSuccess implements Action {
	public readonly type = EMessagesActions.GetConversationsSuccess;

	constructor(public conversations: Conversation[]) {
	}
}

export class GetMessages implements Action {
	public readonly type = EMessagesActions.GetMessages;

	constructor(public id: number, public page_size: number = 50, public page: number = 1) {
	}
}

export class GetMessagesSuccess implements Action {
	public readonly type = EMessagesActions.GetMessagesSuccess;

	constructor(public messages: Message[], public pagination: Pagination) {
	}
}

export class CreateMessage implements Action {
	public readonly type = EMessagesActions.CreateMessage;

	constructor(public id: number, public data: ICreateMessageParams) {
	}
}

export class CreateMessageSuccess implements Action {
	public readonly type = EMessagesActions.CreateMessageSuccess;

	constructor(public message: Message) {
	}
}

export class FilterConversations implements Action {
	public readonly type = EMessagesActions.FilterConversations;

	constructor(public searchString: string) {
	}
}

export class ClearFilteredConversations implements Action {
	public readonly type = EMessagesActions.ClearFilteredConversations;

	constructor() {
	}
}

export class CreateConversation implements Action {
	public readonly type = EMessagesActions.CreateConversation;

	constructor(public data: any, public message: ICreateMessageParams, public conversationName?: string) {
	}
}

export class CreateConversationSuccess implements Action {
	public readonly type = EMessagesActions.CreateConversationSuccess;

	constructor(public conversation: Conversation) {
	}
}

export class ClearMessagesOnConversation implements Action {
	public readonly type = EMessagesActions.ClearMessagesOnConversation;

	constructor() {
	}
}

export class PostMessageFiles implements Action {
	public readonly type = EMessagesActions.PostMessageFiles;

	constructor(public files: File[]) {
	}
}

export class PostMessageFilesSuccess implements Action {
	public readonly type = EMessagesActions.PostMessageFilesSuccess;

	constructor(public filesEntries: FileEntry[]) {
	}
}

export class ClearMessageFiles implements Action {
	public readonly type = EMessagesActions.ClearMessageFiles;

	constructor() {
	}
}

export class CreateNewConversation implements Action {
	public readonly type = EMessagesActions.CreateNewConversation;

	constructor(public newConversation: boolean) {
	}
}

export class SetSelectedConversation implements Action {
	public readonly type = EMessagesActions.SetSelectedConversation;

	constructor(public conversation: Conversation) {
	}
}

export class SetShowOnlyMessages implements Action {
	public readonly type = EMessagesActions.SetShowOnlyMessages;

	constructor(public show: boolean) {
	}
}

export class LeaveConversation implements Action {
	public readonly type = EMessagesActions.LeaveConversation;

	constructor(public id: number) {
	}
}

export class LeaveConversationSuccess implements Action {
	public readonly type = EMessagesActions.LeaveConversationSuccess;

	constructor(public id: number) {
	}
}

export class RenameConversation implements Action {
	public readonly type = EMessagesActions.RenameConversation;

	constructor(public data: any, public id: number) {
	}
}

export class RenameConversationSuccess implements Action {
	public readonly type = EMessagesActions.RenameConversationSuccess;

	constructor(public conversation: Conversation) {
	}
}

export class PushMessageToConversation implements Action {
	public readonly type = EMessagesActions.PushMessageToConversation;

	constructor(public message: Message, public conversation: Conversation) {
	}
}

export type MessagesActions =
	GetConversations |
	GetConversationsSuccess |
	GetMessages |
	GetMessagesSuccess |
	CreateMessage |
	CreateMessageSuccess |
	FilterConversations |
	ClearFilteredConversations |
	CreateConversation |
	CreateConversationSuccess |
	ClearMessagesOnConversation |
	PostMessageFiles |
	PostMessageFilesSuccess |
	ClearMessageFiles |
	CreateNewConversation |
	SetSelectedConversation |
	SetShowOnlyMessages |
	LeaveConversation |
	LeaveConversationSuccess |
	RenameConversation |
	RenameConversationSuccess |
	PushMessageToConversation
	;
